import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import ABOUT from './images/ministry.jpg';

const Background = styled.section`
  background: #ffffff;
  color: #111111;
  padding: 5em 0;
  position: relative;
`;

const HeadingContainer = styled.header`
  padding: 0 1.5em;
  margin-bottom: 2em;
`;

const Heading = styled.h2`
  color: rgba(17, 17, 17, 0.1);
  font-family: DINCondensed-Regular;
  font-size: 5em;
  font-weight: normal;
  letter-spacing: 0.2rem;
  margin: 0;
  position: absolute;
  white-space: nowrap;

  @media (max-width: 767px) {
    right: 0;
    top: 0;
    transform-origin: 100% 0;
    transform: rotate(90deg) translateX(110%);
  }

  @media (min-width: 768px) {
    bottom: 0;
    left: 50%;
    transform: translate(-75%, -10%);
  }
`;

const SubHeading = styled.p`
  background: #ffffff;
  border: 2px solid #111111;
  font-family: 'Noto Serif JP', serif;
  font-size: 1.2em;
  font-weight: bold;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 20em;
  padding: 0.75em 0;
  position: relative;
  text-align: center;
`;

const Container = styled.div`
  padding: 0 1.5em;

  @media (min-width: 768px) {
    align-items: flex-start;
    display: flex;
    margin: 0 auto;
    max-width: 45em;
  }
`;

const Image = styled.img`
  display: block;
  height: auto;
  margin: 0 auto 2em;
  max-width: 80%;

  @media (min-width: 768px) {
    width: 15em;
    margin: 0 2em 0 0;
  }
`;

const TextContainer = styled.div``;

const Text = styled.p`
  margin: 0;
  line-height: 2;
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2em;
`;

const Link = styled.a`
  background: #111111;
  color: #ffffff;
  font-size: 1.1em;
  padding: 1em 1.5em;
  position: relative;
  text-decoration: none;
  z-index: 0;

  &::before {
    background: ${props => props.theme.primary};
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 100%;
    bottom: 0;
    left: 0;
    z-index: -1;
    transition: right 0.5s cubic-bezier(0.02, 0.88, 0.58, 1);
  }

  &:hover::before {
    right: 0;
  }
`;

const About = () => {
  return (
    <Background background="#ffffff">
      <HeadingContainer>
        <Heading>ABOUT &quot;PSYCHO-PASS&quot;</Heading>
        <SubHeading>
          <Translate id="psyLandingPage.about.subtitle" />
        </SubHeading>
      </HeadingContainer>
      <Container>
        <Image src={ABOUT} />
        <TextContainer>
          <Text>
            <Translate id="psyLandingPage.about.main.1" />
          </Text>
          <Text>
            <Translate id="psyLandingPage.about.main.2" />
          </Text>
          <LinkContainer>
            <Link
              href="https://psycho-pass.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Translate id="psyLandingPage.about.link" />
            </Link>
          </LinkContainer>
        </TextContainer>
      </Container>
    </Background>
  );
};

export default About;
